import { useRouter } from 'next/router'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { PaginationInterface } from 'shared/types/swr-pagination-interface'
import { TEMPLATES_API } from '../api/templates-api'
import { TemplatesFilterInterface, TemplatesLimitType } from '../types/templates-filter-interface'
import { TemplatesApiInterface } from '../types/templates-interface'

interface UseTemplatesInterface {
  filter: TemplatesFilterInterface
  pagination: PaginationInterface
  limit: TemplatesLimitType
}

interface UseTemplatesResult {
  templates: TemplatesApiInterface | undefined
}

export const useTemplates = ({
  limit,
  pagination,
  filter,
}: UseTemplatesInterface): UseTemplatesResult => {
  const { locale, isReady } = useRouter()
  const fetcherWithErrorValidation = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    TemplatesApiInterface
  >({ method: RequestMethodsEnum.get })

  const filterApi = `${
    filter.category !== null ? `&filter[category]=${filter.category}` : ''
  }&filter[locale]=${locale}`

  const { data: templates } = useSWR<TemplatesApiInterface>(() => {
    if (!isReady || !locale || !limit) return null
    if (pagination.startFromId === undefined) {
      return `${TEMPLATES_API}/list?pagination[limit]=${limit}${filterApi}`
    } else {
      return `${TEMPLATES_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
    }
  }, fetcherWithErrorValidation)

  return { templates }
}
